'use strict';

import Api from "./Api";

export default class Subscription extends Api {

    static getList(page = 1, perPage = 10, sort = undefined) {
        const url = this.url + 'subscription/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
            },
        });
    }

    static getListActive(page = 1, perPage = 10, sort = undefined) {
        const url = this.url + 'subscription/list-active';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
            },
        });
    }

    static get(id) {
        const url = this.url + 'subscription/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'subscription/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'subscription/update';

        return this.getAxios().post(url, data);
    }

}
